/**
 * Renewal Shared Constants Index
 *
 * 이 파일은 shared 상수들을 통합하여 export합니다.
 */

// Color Constants
export * from "./color";

// Typography Constants
export * from "./typography";

// Spacing Constants
export * from "./spacing";

// Component Constants
export * from "./component";

// Theme Constants
export * from "./theme";

// Re-export commonly used constants for convenience
export { COLOR_CONSTANTS as COLOR } from "./color";
export { TYPOGRAPHY } from "./typography";
export { SPACING_CONSTANTS as SPACING } from "./spacing";
export { COMPONENT_CONSTANTS as COMPONENTS } from "./component";
export { THEME_CONSTANTS as THEME } from "./theme";
